import { render, staticRenderFns } from "./NotentransferMitgliederSelection.vue?vue&type=template&id=61e17a7e&"
import script from "./NotentransferMitgliederSelection.vue?vue&type=script&lang=js&"
export * from "./NotentransferMitgliederSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports